import { useTranslation } from 'react-i18next'
import { IconCashOut } from '../../../../shared/components/icons/IconCashOut'
import { IconMoneyWithdrawal } from '../../../../shared/components/icons/IconMoneyWithdrawal'
import { IconShareLink } from '../../../../shared/components/icons/IconShareLink'
import styles from './HowItWorks.module.scss'

export const HowItWorks = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.root}>
      <div className={styles.card}>
        <div className={styles.icon}>
          <IconMoneyWithdrawal color={'#A059FF'} />
        </div>
        <p className={styles.title}>
          1. {t('pages.referralProgram.shareInstruction')}
        </p>
        <p className={styles.desc}>
          {t('pages.referralProgram.passThisAlong')}
        </p>
      </div>
      <div className={styles.card}>
        <div className={styles.icon}>
          <IconShareLink color={'#A059FF'} />
        </div>
        <p className={styles.title}>
          2. {t('pages.referralProgram.earnInstruction')}
        </p>
        <div className={styles.cardNested}>
          <p className={styles.descNested}>
            {t('pages.referralProgram.supportPayoutModels')}:
          </p>
          <ul className={styles.list}>
            <li>{t('pages.referralProgram.perAction')}</li>
            <li>{t('pages.referralProgram.commissionBased')}</li>
            <li>{t('pages.referralProgram.hybrid')}</li>
          </ul>
        </div>
      </div>
      <div className={styles.card}>
        <div className={styles.icon}>
          <IconCashOut color={'#A059FF'} />
        </div>
        <p className={styles.title}>
          3. {t('pages.referralProgram.withdrawInstruction')}
        </p>
        <p className={styles.desc}>
          {t('pages.referralProgram.withdrawNotification')}
        </p>
      </div>
    </div>
  )
}
